<template>
    <div>
        <v-layout wrap justify-center align-center v-if="mostrarContenido == 1">
            <v-flex md7 sm7 xs12>
                <dialogos-app :dialogos="dialogos" tucan="2"></dialogos-app>
            </v-flex>
        </v-layout>
        <!-- Primer contenido-->
        <v-layout wrap row justify-center align-center text-md-center mt-5 class="cont_page animated fadeInDown dura-1" v-if="mostrarContenido == 1">
          <v-flex xs11 sm7 md7 mb-2 text-xs-center v-for="i in 3" :key="'item'+i">
            <div class="btn-blue-dark hvr hvr-scale" @click="mostrarModal(i)" :class="{'btn-visto':modalVistos[i-1]}">
              <span>{{textBtn[i-1]}}</span>
            </div>
          </v-flex>
        </v-layout>
        <!-- Segundo contenido-->
        <v-layout wrap row justify-center align-center text-md-center mt-5 class="cont_page animated fadeIn dura-1" v-if="mostrarContenido == 2">
          <v-flex xs12 sm7 md7>
          <!-- dialogo tuca -->
            <v-layout class="animated fadeInLeft dura-2" row>
              <div class="imagen-personaje"><img src="@/assets/imagenes_compartidas/tucan-1.png" alt=""></div>
              <v-flex xs11 md11 class="cont-dialogo">
                <p>Obrigado, Eduardo!</p>
              </v-flex>
            </v-layout>
          <!-- dialogo hombre -->
            <v-layout class="animated fadeInRight dura-4" row mt-3>
              <v-flex xs11 md11 class="cont-dialogo">
                <p>Vamos ver o que você já aprendeu? Clique em avançar e faça os exercícios.</p>
              </v-flex>
              <div class="imagen-personaje-hombre"></div>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm7 md7 text-xs-center mt-5 class="animated fadeInUp dura-5">
            <button class="hvr hvr-scale btn-white-dark" @click="avanzar()"><span>Avançar</span></button>
          </v-flex>
        </v-layout>
       
        <!-- modal para primer contenido -->
        <modal-app v-model="modal" :fullscreen="true" >
            <template slot="modaltittle">
                <h1 class="modal-icon-title"></h1>
            </template>
            <v-layout row wrap>
              <v-flex xs12 md12>
              <modalslide1 v-if="modalnum == 0"></modalslide1>
              <modalslide2 v-if="modalnum == 1"></modalslide2>
              <modalslide3 v-if="modalnum == 2"></modalslide3>
              </v-flex>
            </v-layout>
        </modal-app>
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
import modalslide1 from '@/pages/unidad1/slide-mod3/modalslide1';
import modalslide2 from '@/pages/unidad1/slide-mod3/modalslide2';
import modalslide3 from '@/pages/unidad1/slide-mod3/modalslide3';

export default {
    components: {
      modalslide1,
      modalslide2,
      modalslide3
    },
  mixins: [nextConditions],
  data() {
    return {
      dialogos: [
        'Vamos ver como as pessoas se cumprimentam no Brasil?',
        'Clique e conheça as expressões abaixo:',
      ],
      mostrarContenido:1,
      textBtn:[
        'Cumprimentos','Despedidas','Apresentações'
      ],
      modal:false,
      modalnum:null,
      modalVistos:Array(3).fill(false)
    }
  },
  methods: {
    mostrarModal(val){
      this.modal = true
      this.modalnum = val-1
      this.$set(this.modalVistos,val-1,true)
      var todosVistos = this.modalVistos.every(el => {return el})
      if(todosVistos){
        setTimeout(() => {
          this.mostrarContenido = 2
        }, 2000);
          // this.$store.commit('nextShow', true);
      }
    },
    avanzar(){
      this.$router.push('/unidad1/4')
    }
  }
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../sass/globals';
.imagen-personaje{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: -20px;
  z-index: 1;
      img {
        width: 70px;
    }
}
.cont-dialogo{
  background: #81C7FD;
  padding: 10px 20px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  p{
    margin: 0;
    padding: 0;
    font-family:Poppins-Regular;
    font-size: 13px;

  }
}
.imagen-personaje-hombre{
  background: url('../../assets/unidad1/slide-3-1.jpg')no-repeat 70% 40%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -20px;
  z-index: 1;
  width: 70px;
  height: 70px;
  background-size: 110px;
  border-radius: 50%;
}
.btn-visto{
  background: gray;
}
</style>
